var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mdt-lightbox"},[_c('vue-easy-lightbox',{attrs:{"move-disabled":"","visible":_vm.lightbox.visible,"imgs":_vm.lightbox.images,"index":_vm.lightbox.index},on:{"hide":_vm.hideLightbox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }